import { render, staticRenderFns } from "./GameChoiceItem.vue?vue&type=template&id=0f50211c&scoped=true&"
import script from "./GameChoiceItem.vue?vue&type=script&lang=js&"
export * from "./GameChoiceItem.vue?vue&type=script&lang=js&"
import style0 from "./GameChoiceItem.vue?vue&type=style&index=0&id=0f50211c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f50211c",
  null
  
)

export default component.exports